import Marquee from "react-fast-marquee";

const pillars = [
  "PHYSIOTHERAPY FOR ELDERLY",
  "REHAB FOR ATHLETES",
  "SPECIAL NEEDS CARE",
  "FREE COMMUNITY CAMPS",
  "HOME VISIT SUPPORT",
];

export const PillarsMarquee = () => (
  <div className="border-y border-border bg-secondary py-6 overflow-hidden">
    <Marquee speed={70} gradient={false}>
      {pillars.concat(pillars).map((p, i) => (
        <span key={i} className="font-heading text-2xl md:text-4xl mx-8 text-foreground/80 tracking-tight whitespace-nowrap">
          {p} <span className="text-accent mx-6">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
